<template>
  <div class="route-status">
    <h4>Estado:</h4>
    <b-form>
      <b-form-group id="status-group">
        <b-form-radio-group
          id="status"
          name="status"
          v-model="selected"
          :options="options"
          :state="errors.first('status') ? 'invalid' : ''"
          v-validate="'required'"
        ></b-form-radio-group>
        <small class="text-danger">{{ errors.first('status') }}</small>
      </b-form-group>

      <b-form-group>
        <b-button variant="primary" size="sm" @click="onSubmitStatus">Actualizar Estado</b-button>
      </b-form-group>
    </b-form>
    <hr>
  </div>
</template>

<script>
export default {
  name: 'RouteStatus',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      selected: this.status,
      options: [
        { text: 'En Espera', value: 'inactive', disabled: true },
        { text: 'En Curso', value: 'active' },
        { text: 'Terminado', value: 'delivered' },
        { text: 'Cancelado', value: 'cancelled' }
      ]
    }
  },
  methods: {
    onSubmitStatus () {
      console.log('Validando..')
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.$emit('onUpdateStatus', this.selected)
          }
        })
        .catch((err) => {
          console.log('No valido')
          console.log(err)
        })
    }
  }
}
</script>
